import React, { useMemo } from 'react'
import { Button, InfoAlert, Title } from '@arvoreeducacao/bonsai-ds'
import { useTranslation } from 'i18n'
import {
  AlertWrapper,
  ButtonWrapper,
  SelectedItem,
  SelectedItemsList,
  SelectedItemsWrapper,
  SelectedItemsWrapperTitle,
  Wrapper
} from './ThirdStep.style'
import type { ThirdStepProps } from '../NewReadingGoalModal.types'
import type { ReadingGoal } from 'api/data.types'

const ThirdStep: React.FC<ThirdStepProps> = ({
  handlePreviousStep,
  selectedClasses,
  selectedReadingGoalTime,
  currentReadingGoals,
  submitting,
  handleSubmit
}) => {
  const { t } = useTranslation()
  const showAlert = useMemo(
    () =>
      currentReadingGoals?.some((readingGoal: ReadingGoal) =>
        selectedClasses.some(c => c.id === readingGoal.entityId)
      ),
    [currentReadingGoals, selectedClasses]
  )

  return (
    <Wrapper>
      <Title size={3}>{t('Revise a nova meta de leitura')}</Title>

      <SelectedItemsWrapperTitle>
        {t('Turmas selecionadas')}
      </SelectedItemsWrapperTitle>
      <SelectedItemsWrapper scrollable>
        <SelectedItemsList>
          {selectedClasses.map(selectedClass => {
            return (
              <SelectedItem key={selectedClass.id}>
                {selectedClass.label}
              </SelectedItem>
            )
          })}
        </SelectedItemsList>
      </SelectedItemsWrapper>

      <SelectedItemsWrapperTitle>{t('Meta Semanal')}</SelectedItemsWrapperTitle>
      <SelectedItemsWrapper>
        <SelectedItemsList>
          <SelectedItem>
            {selectedReadingGoalTime} {t('min')}
          </SelectedItem>
        </SelectedItemsList>
      </SelectedItemsWrapper>

      {showAlert && (
        <AlertWrapper>
          <InfoAlert
            hasMarketList
            boldTitle
            title={t('Atualização de metas')}
            description={t(
              'Identificamos que uma das turmas já tem metas de leitura atribuídas, a nova meta irá substituir as metas antigas.'
            )}
            icon="warning"
            variant="warning"
          />
        </AlertWrapper>
      )}

      <ButtonWrapper>
        <Button
          theme={{ type: 'secondary', size: 'large' }}
          text={t('Voltar')}
          onClick={handlePreviousStep}
        />
        <Button
          theme={{ type: 'primaryLivros', size: 'large' }}
          text={t('Aplicar meta')}
          loading={submitting}
          onClick={handleSubmit}
        />
      </ButtonWrapper>
    </Wrapper>
  )
}

export default ThirdStep
